
import { defineComponent, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import { ALERT_COLORS } from '@/store/base'
import LayoutsAuth from '@/layouts/Auth.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, BaseAlert, BaseFormSubmit, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)
    const initialValues = computed(() => {
      return {
        nick_name: store.state.user.user?.nick_name,
      }
    })

    const schema = yup.object({
      nick_name: yup.string().nullable().max(10),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema, initialValues })

    const { value: nick_name } = useField<string>('nick_name')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/account/change-nick-name', values)
        .then(response => {
          store.commit('user/setUser', response.data.payload)
          store.commit('base/setAlertMessages', { messages: [t('account.change_nick_name.success')], color: ALERT_COLORS.info })
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      nick_name,
      onSubmit,
      btnDisabled
    }
  },
})
